<template>
  <WrapperForm
    v-model="currentTab"
    :tabs
    :customClass="['scrollable', 'scrollbar']"
  >
    <component :is="TABS_COMPONENTS[currentTab]" />
  </WrapperForm>
</template>

<script setup lang="ts">
  import type { ActionFormationDTO } from '@/features/api/extranet/dto/Demande/AF'
import { type ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import DocumentsContent from '@/features/interface/demande/af/steps/documents/DocumentsStep.vue'
import EmployeurContent from '@/features/interface/demande/af/steps/employeur/EmployeurStep.vue'
import FormationContent from '@/features/interface/demande/af/steps/formation/FormationStep.vue'
import IntroductionContent from '@/features/interface/demande/af/steps/introduction/IntroductionStep.vue'
import SalarieContent from '@/features/interface/demande/af/steps/salarie/SalarieStep.vue'
import SyntheseContent from '@/features/interface/demande/af/steps/synthese/SyntheseStep.vue'
import { useDemandeTabsSummarizer } from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { ref, type Component } from 'vue'
import { useDemandeAFStore } from './useDemandeAFStore'

  const TabKeys = ['Introduction', 'Employeur', 'Salariés', 'Formation', 'Synthèse', 'Documents'] as const
  type TabKey = (typeof TabKeys)[number]

  const TABS_COMPONENTS: { [key in TabKey]?: Component } = {
    Introduction: IntroductionContent,
    Employeur: EmployeurContent,
    Formation: FormationContent,
    Salariés: SalarieContent,
    Synthèse: SyntheseContent,
    Documents: DocumentsContent,
  } as const

  const currentTab = ref(TabKeys[0])

  const config: ErreurSummaryConfiguration<ActionFormationDTO> = {
    Introduction: { include: (state) => [state.validationNotice] },
    Employeur: {
      includeDeep: (state) => [state.employeur],

      // A Utiliser au besoin
      /*
      exclude: (state) => [],
      excludeDeep: (state) => [],
      */
    },
    Formation: { includeDeep: (state) => [state.formation, state.sousDispositif] },
    Salariés: {
      includeDeep: (state) => [state.salaries],
      include: (state) => [state.attestationSalariesSaisies],
    },
    Synthèse: { include: (state) => [state.commentaire, state.acceptationCg, state.attestationSurHonneur] },
    Documents: {
      includeDeep: (state) => [state.fichiers],
      include: (state) => [state.attestationPiecesJustificatives],
    },
  }

  const { meta } = storeToRefs(useDemandeAFStore())

  const { tabs } = useDemandeTabsSummarizer<ActionFormationDTO>(config, meta)
</script>
